<template>
	<div class="page-container mobile flex-column px-3 pt-4">
		<InstallablePreview class="width-100" :installableId="installableId" />
		<div class="mobile-title">{{ titleText }}</div>
		<div v-if="user" class="mt-3 mobile-title-description">Complete setup from desktop</div>
		<div class="mobile-description mt-2">
			Ply uses a chrome extension to add features to your apps. We’ve sent you a link to your feature
		</div>
		<SIcon class="my-2" width="100%" name="feature-installed-mobile" />
		<div class="mobile-title-description mt-8">Share this feature</div>
		<div class="mt-3 pl-2 pr-1 width-100 display-flex flex-row flex-align-center flex-justify-space-between share-address-container">
			<div class="address-text">{{ installableHref }}</div>
			<AnemicButton @click="copyToClipboard" class="copy-button">
				<SIcon name="copy-installable-to-clipboard" width="11px" class="mr-1" />
				<div>Copy</div>
			</AnemicButton>
		</div>
		<div class="mt-3 width-100 display-flex flex-row flex-align-center flex-justify-space-between share-buttons-container">
			<div>Share:</div>
			<div class="display-flex flex-row flex-align-center">
				<AnemicButton
					target="_blank"
					:key="icon.name"
					:href="icon.href"
					class="icon-button"
					v-for="(icon, i) in shareIcons"
					:class="{ 'mr-2': i !== shareIcons.length - 1 }"
				>
					<SIcon :name="icon.name" />
				</AnemicButton>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { appURL } from '@/store/modules/main/getters';
import InstallablePreview from '@/components/Project/InstallablePreview.vue';
export default {
	name: 'MobileInstallation',
	props: { installableId: { type: String } },
	components: { InstallablePreview },
	computed: {
		...mapGetters(['user']),
		...mapGetters([appURL.fullPath]),
		shareIcons() {
			return [
				{ name: 'share-twitter', href: this.twitterHref },
				{ name: 'share-linkedin', href: this.linkedinHref },
			];
		},
		titleText() {
			if (this.user) {
				return 'Feature installed';
			} else {
				return 'Check your inbox from desktop';
			}
		},
		installableHref() {
			const installableId = this.installableId || this.$route.query?.installableId;
			return `${this[appURL.fullPath]}installation/${installableId}`;
		},
		shareDescription() {
			return `Check out this feature`;
		},
		twitterHref() {
			return `http://twitter.com/share?text=${this.shareDescription}&url=${this.installableHref}`;
		},
		linkedinHref() {
			return `https://www.linkedin.com/sharing/share-offsite/?url=${this.installableHref}`; //does not work locally. (because of flowbuilder.local....)
		},
	},
	methods: {
		copyToClipboard() {
			navigator.clipboard
				.writeText(this.installableHref)
				.then(() => this.$toast.success('Copied URL'))
				.catch(() => this.$toast.error('Something went wrong...'));
		},
	},
};
</script>

<style lang="scss" scoped>
.page-container {
	width: 100vw;
	height: 100vh;
	&.mobile {
		background: var(--setup-node-container-background);
	}
}

.mobile-title-description {
	font-size: 18px;
	font-weight: bold;
	text-align: center;
	color: var(--primary-font-color);
}

.mobile-title {
	margin-top: 40px;

	font-size: 25px;
	font-weight: bold;
	text-align: center;
	color: var(--primary-font-color);
}

.mobile-description {
	font-size: 16px;
	text-align: center;
	letter-spacing: 0.32px;
	color: var(--primary-font-color);
}

.share-address-container {
	border-radius: 8px;
	background: var(--border-color);
	height: 40px;
}

.address-text {
	opacity: 0.54;
	font-size: 14px;
	color: var(--primary-font-color);
	margin-right: 10px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.copy-button {
	border-radius: 4px !important;
	background: var(--bg-color) !important;
	padding: 0px !important;
	width: 60px !important;
	height: 24px !important;
	font-size: 12px !important;
	color: var(--tutorial-vido-description) !important;
}

.icon-button {
	width: 46px !important;
	height: 46px !important;
	padding: 0px !important;
	border: 1px solid var(--button-border);
	background: var(--bg-color) !important;
}
</style>
